<template>
  <sticky-header-layout>
    <template #header>
       <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isLoading"
            class="save-button"
            size="mini"
            type="success"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <el-form
      ref="form"
      :disabled="isLoading"
      :model="form"
      class="round-border-form"
      label-position="top"
      label-width="200"
    >
      <div class="form-group">
        <el-form-item label="Effect Time">
          <el-date-picker
            v-model="dateValue"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="Start date"
            end-placeholder="End date">
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Top Image (Desktop)">
          <el-input
            v-model="form.homepage_takeover_top_image_desktop"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Top Image (Mobile)">
          <el-input
            v-model="form.homepage_takeover_top_image_mobile"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Left Image (Desktop)">
          <el-input
            v-model="form.homepage_takeover_left_image_desktop"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Left Image (Mobile)">
          <el-input
            v-model="form.homepage_takeover_left_image_mobile"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Right Image (Desktop)">
          <el-input
            v-model="form.homepage_takeover_right_image_desktop"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Right Image (Mobile)">
          <el-input
            v-model="form.homepage_takeover_right_image_mobile"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Scrollable">
          <el-switch 
          active-value="1"
          inactive-value="0"
          v-model="form.homepage_takeover_scrollable" />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Media Type">
          <el-input
            v-model="form.homepage_takeover_media_type"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Middle Image (Desktop) Top">
          <el-input
            v-model="form.homepage_takeover_middle_image_desktop_top"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Middle Image (Desktop) Bottom">
          <el-input
            v-model="form.homepage_takeover_middle_image_desktop_bottom"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Middle Image (Mobile) Top">
          <el-input
            v-model="form.homepage_takeover_middle_image_mobile_top"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item label="Middle Image (Mobile) Bottom">
          <el-input
            v-model="form.homepage_takeover_middle_image_mobile_bottom"
            clearable
          />
        </el-form-item>
      </div>
      <div class="form-group">
        <el-form-item
          label="Country"
          prop="country"
        >
          <el-select
            :placeholder="$t('placeholder.select')"
            v-model="availableCountries"
            class="w-100"
            multiple
          >
            <el-option
              key="all"
              label="All"
              value="all"
            />
            <el-option
              v-for="item in countryList"
              :key="item.code.toLowerCase()"
              :label="item.code"
              :value="item.code.toLowerCase()"
            />
          </el-select>
        </el-form-item>
      </div>

      <el-tabs 
        type="card"
      >
        <el-tab-pane
          v-for="country in availableCountries"
          :key="country"
          :label="country.toUpperCase()"
          :name="country"
        >
          <div>
            <div class="form-group">
              <el-form-item label="Top Url">
                <el-input
                  v-model="form.available_countries[country].homepage_takeover_top_url"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="form-group">
              <el-form-item label="Left Url">
                <el-input
                  v-model="form.available_countries[country].homepage_takeover_left_url"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="form-group">
              <el-form-item label="Right Url">
                <el-input
                  v-model="form.available_countries[country].homepage_takeover_right_url"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="form-group">
              <el-form-item label="Middle Image Top Url">
                <el-input
                  v-model="form.available_countries[country].homepage_takeover_middle_image_top_url"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="form-group">
              <el-form-item label="Middle Image Bottom Url">
                <el-input
                  v-model="form.available_countries[country].homepage_takeover_middle_image_bottom_url"
                  clearable
                />
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    
  </sticky-header-layout>
</template>

<script>
import HomeConfigsAPI from '../../api/home-configs'
import MarketplaceService from '../../api/marketplace'
import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'
import { formatDatetime } from '../../utils/datetime'
export default {
  name: 'HomepageTakeover',
  components: {
    ListPageHeader
  },
  data() {
    return {
      dateValue: null,
      countryList: [],
      form: {
        homepage_takeover_start_time: '',
        homepage_takeover_end_time: '',
        homepage_takeover_top_image_desktop: '',
        homepage_takeover_top_image_mobile: '',
        homepage_takeover_left_image_desktop: '',
        homepage_takeover_left_image_mobile: '',
        homepage_takeover_right_image_desktop: '',
        homepage_takeover_right_image_mobile: '',
        homepage_takeover_scrollable: 0,
        homepage_takeover_media_type: '',
        homepage_takeover_middle_image_desktop_top: '',
        homepage_takeover_middle_image_desktop_bottom: '',
        homepage_takeover_middle_image_mobile_top: '',
        homepage_takeover_middle_image_mobile_bottom: '',
        available_countries: {},
      },
      // isEdited: false,
      isLoading: false,
      // isSaving: false,
    }
  },
  computed: {
    availableCountries: {
      get() {
        return Object.keys(this.form.available_countries)
      },
      set(new_available_countries) {
        for (let c in this.form.available_countries) {
          if (!new_available_countries.includes(c)) {// delete the one not exist anymore
            delete this.form.available_countries[c]
          } 
        }

        for (let c of new_available_countries) { // add new 
          if (!this.form.available_countries[c]) {
            this.form.available_countries[c] = {}
          }
        }

        let all_index = new_available_countries.indexOf('all')
        if (all_index >= 0) {
          if (all_index == new_available_countries.length - 1) {
            this.form.available_countries = {'all': {}}
          } else {
            delete this.form.available_countries['all']
          }
        }

        //need to let vue know obj update
        this.form.available_countries = Object.assign({}, this.form.available_countries)
      }
    },
  },
  mounted() {
    this.getHomepageTakeover()
    this.getCountryList()
  },
  methods: {
    formatDatetimeToUTC(date) {
      return formatDatetime({ date: date, timezoneOffset: -8})
    },
    validateTabItems() {
      for (let c in this.form.available_countries) {
        const tab = this.form.available_countries[c]
        const hasValidInput = !!tab.homepage_takeover_top_url || tab.homepage_takeover_left_url || tab.homepage_takeover_right_url || tab.homepage_takeover_middle_image_top_url || tab.homepage_takeover_middle_image_bottom_url
        if (!hasValidInput) {
          return false
        }
      }
      return true
    },
    async handleSave() {
      if (!this.form.available_countries) {
        this.$message({
          message: 'Please select available',
          type: 'error',
        });
        return
      }
      if (!this.validateTabItems()) {
        this.$message({
          message: 'Please fill in all data.',
          type: 'error',
        });
        return
      }

      if (!this.dateValue) {
        this.form.homepage_takeover_start_time = ''
        this.form.homepage_takeover_end_time = ''
      } else {
        this.form.homepage_takeover_start_time = this.formatDatetimeToUTC(this.dateValue[0])
        this.form.homepage_takeover_end_time = this.formatDatetimeToUTC(this.dateValue[1])
      }

      this.isLoading = true
      try {
        const result = await HomeConfigsAPI.updateHomepageTakeover(this.form)
      } catch (error) {
        this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
          type: 'error',
          confirmButtonText: 'OK',
        })
      } finally {
        this.isLoading = false
      }
      
    },
    async getCountryList() {
      this.isLoading = true
      const res = await MarketplaceService.getCountryList()
      if (Array.isArray(res.data)) {
        this.countryList = [...res.data]
      }
      this.isLoading = false
    },
    async getHomepageTakeover() {
      this.isLoading = true
      try {
        const response = await HomeConfigsAPI.getHomepageTakeoverDetail()
        this.form = response.data
        if (this.form.homepage_takeover_start_time && this.form.homepage_takeover_end_time) {
          this.dateValue = [formatDatetime({date: this.form.homepage_takeover_start_time}), formatDatetime({date: this.form.homepage_takeover_end_time})]
        }

        this.$nextTick(() => {
          // this.isEdited = false
          this.isLoading = false
        })
      } catch (error) {
        // console.log(error)
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";
</style>

<style lang="scss">
.el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
